import { render } from "./DialogCancelLoading.vue?vue&type=template&id=331f9aeb"
import script from "./DialogCancelLoading.vue?vue&type=script&lang=js"
export * from "./DialogCancelLoading.vue?vue&type=script&lang=js"
script.render = render

export default script